/**
 * Site-wide SEO constants. The SEO owner can edit these.
 * SITE_URL is the public origin + the `/in` base path, with no trailing slash.
 */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://alearninglab.in").replace(/\/+$/, "");
export const SITE_NAME = "A Learning Lab India";
export const ORG_NAME = "A Learning Lab by UniHawk";
export const DEFAULT_TITLE = "A Learning Lab India | Career Exploration & Virtual Internships for Students";
export const DEFAULT_DESCRIPTION =
  "A Learning Lab India offers virtual internships, bootcamps and career exploration programmes for school students across India.";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/A-Learning-Lab-Logo.png`;
export const TWITTER_HANDLE = ""; // e.g. "@alearninglab" (leave empty to omit)

/** Builds an absolute canonical URL from an in-app path ("/" -> SITE_URL, "/contact" -> SITE_URL/contact). */
export function absoluteUrl(path = "/") {
  const clean = path === "/" ? "" : `/${String(path).replace(/^\/+|\/+$/g, "")}`;
  return `${SITE_URL}${clean}`;
}
